import type { Question } from '../../types';
import { useControlDisabled } from './ControlDisabledContext';

/** Layout disabled-when stacked with question_db ui_editing_disabled. */
export function useQuestionFieldDisabled(
  question: Question | undefined
): boolean {
  const inheritedDisabled = useControlDisabled();
  return inheritedDisabled || question?.ui_editing_disabled === true;
}
